<template>
  <div>
    <div v-for="(item, index) in sortedItems" :key="`${index}-${item.value}`">
      <v-card-text v-if="getCheckboxLabel(item.value) && (showAllItems || index <= maxItemDisplay)" class="d-flex justify-space-between pa-2 ma-0">
        <v-checkbox
          :disabled="isActiveFilter(attribute, item.value) ? false : item.count === 0"
          hide-details
          :label="getCheckboxLabel(item.value)"
          :input-value="isActiveFilter(attribute, item.value)"
          class="
            pa-0 ma-0
          "
          @click="applyValue(item.value)"
        />
        <v-chip v-if="!hideCount">
          {{ item.count }}
        </v-chip>
      </v-card-text>
    </div>
    <div v-if="computedItems.length - 1 > maxItemDisplay" class="d-flex justify-center">
      <span v-if="!showAllItems" class="pointer text-decoration-underline" @click="showAllItems = true">En savoir plus</span>
      <span v-else class="pointer text-decoration-underline" @click="showAllItems = false">Afficher moins</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    attribute: {
      type: String,
      default: null
    },
    checkboxDefaultValueLabels: {
      type: Object,
      default: () => ({})
    },
    maxItemDisplay: {
      type: Number,
      default: 5
    },
    hideCount: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeValue: [],
      showAllItems: false
    };
  },
  computed: {
    ...mapGetters(['isActiveFilter']),
    computedItems () {
      if (Object.keys(this.checkboxDefaultValueLabels).length === 0) {
        return this.items;
      }

      return this.items.filter(item => !!(this.checkboxDefaultValueLabels[item.value] ?? item.value));
    },
    sortedItems () {
      return [...this.computedItems].sort((a, b) => {
        const aActive = this.activeValue.includes(a.value);
        const bActive = this.activeValue.includes(b.value);

        return bActive - aActive;
      });
    }
  },
  methods: {
    ...mapActions(['applyFilter']),
    applyValue (value) {
      this.applyFilter({ attribute: this.attribute, value: value });
    },
    getCheckboxLabel (value) {
      return this.checkboxDefaultValueLabels[value] ?? value;
    }
  }
};
</script>
